import { COLOR, FONT_SIZE, Button as _Button, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const fadeIn = keyframes`
  from {
    opacity: 0;
    height: 0px;
  }
  to {
    opacity: 1;
    height: 330px;
  }
`;
const fadeOut = keyframes`
  from {
    opacity: 1;
    height: 330px;
  }
  to {
    opacity: 0;
    height: 0px;
  }
`;
// 親要素のbottom位置
const top = 36;
export const DivSearchHistoryScrollWrapper = styled.div<{
  isOpen: boolean;
}>`
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  position: absolute;
  left: 0;
  top: ${top}px;
  margin-top: 8px;
  width: 100%;
  height: 330px;
  overflow-y: auto;
  background-color: rgb(${COLOR.GRAY100.rgb});
  border-radius: 4px;
  animation: ${({ isOpen }) => (isOpen ? fadeIn : fadeOut)} 0.15s cubic-bezier(0.42, 0, 1, 0.87);
  transition: all 0.15s cubic-bezier(0.42, 0, 1, 0.87);
`;

export const DivSearchHistoryWrapper = styled.div`
  padding: 8px;
`;

export const DivHeadingSearchHistory = styled.div`
  font-size: ${FONT_SIZE.M}px;
  padding: 8px;
  font-weight: ${FONT_WEIGHT.BOLD};
  height: 40px;
`;

export const UlSearchHistoryList = styled.ul`
  > li {
    font-size: ${FONT_SIZE.S}px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 8px;
  }
`;

export const ButtonClearSearchHistory = styled(_Button)`
  width: 16px;
  height: 16px;
`;
